export default "__VITE_ASSET__BEcn$a6o__"